// extracted by mini-css-extract-plugin
export default {"base":"PrincipalTorneo_base__3MYbP","titulo":"PrincipalTorneo_titulo__XHcwb"};